import { render, staticRenderFns } from "./accountMixCheckRecord.vue?vue&type=template&id=a650972e&scoped=true"
import script from "./accountMixCheckRecord.vue?vue&type=script&lang=ts"
export * from "./accountMixCheckRecord.vue?vue&type=script&lang=ts"
import style0 from "./accountMixCheckRecord.vue?vue&type=style&index=0&id=a650972e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a650972e",
  null
  
)

export default component.exports